import React, { Component } from "react"
import * as helpers from "../../helpers/sectionclasses"
import parse from "html-react-parser"

class ContentBlock extends Component {
  render() {
    const content = this.props.content
    const blogPost = this.props.blogPost
    const sectionClasses = helpers.sectionClasses(
      content.sectionOptions,
      blogPost
    )
    
    if (content.content) {
      return (
        <section className={`${sectionClasses}`}>
          <div className="container">
            <div className="w-full flex justify-center">
              <div className="lrg:w-8/12 lrg:px-6 article-body content-block">
                {parse(content.content)}
              </div>
            </div>
          </div>
        </section>
      )
    } else {
      return <p>.</p>
    }
  }
}

export default ContentBlock
